module.exports = __webpack_public_path__ + "img/function_opend.154c84dd.svg";